import { motion } from "framer-motion";

export function HomeContactBlock() {
  return (
    <section id="contact" className="py-16 lg:py-20 border-t border-border/30">
      <div className="max-w-2xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-5 leading-tight">
            Contact
          </h2>
          <p className="text-[17px] text-muted-foreground leading-[1.75]">
            For Task Force matters, write to{" "}
            <a
              href="mailto:david.isei@hawaiihealthcaretaskforce.org"
              className="text-accent hover:text-accent/80 transition-colors font-medium"
            >
              david.isei@hawaiihealthcaretaskforce.org
            </a>
            . For everything else,{" "}
            <a
              href="mailto:davidisei@iseiconsultingllc.com"
              className="text-accent hover:text-accent/80 transition-colors font-medium"
            >
              davidisei@iseiconsultingllc.com
            </a>{" "}
            or{" "}
            <a href="tel:+18084892924" className="text-accent hover:text-accent/80 transition-colors font-medium">
              (808) 489-2924
            </a>
            .
          </p>
        </motion.div>
      </div>
    </section>
  );
}
